// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ErrorBox_wrapper__37WJm"};